// helpers/iconStyle.ts
import type { CSSProperties } from "react";

export const withIconStyle = (color?: string, size = 18, strokeWidth = 1.75) => ({
  size,
  strokeWidth,
  style: color ? ({ color } as CSSProperties) : undefined, // Lucide uses currentColor
});

export const iconLabelProps = (fontSize?: number, extraClass = "") => ({
  className: `fw-bold d-flex align-items-center gap-2 ${extraClass}`.trim(),
  style: fontSize ? ({ fontSize } as CSSProperties) : undefined,
});
